import { useState } from 'react';
import { EditSquare } from '@mui/icons-material';
import { Button } from '@practium/ui';
import styles from './MapRightPanel.module.css';
import { BrazilMapGL } from '../Map/BrazilMap/BrazilMapGL';
import { hasMapboxToken } from '../../utils/mapboxUtils';

const hasToken = hasMapboxToken();

interface MapRightPanelProps {
	step: 'selectBase' | 'editRegion';
	regionName: string;
	selectedStateCodes: string[];
	isEditMode?: boolean;
	onNameChange: (name: string) => void;
	onSkip: () => void;
	onConfirm: () => void;
}

export const MapRightPanel = ({
	step,
	regionName,
	selectedStateCodes,
	isEditMode = false,
	onNameChange,
	onSkip,
	onConfirm,
}: MapRightPanelProps) => {
	const isSelectBase = step === 'selectBase';
	const [isEditing, setIsEditing] = useState(false);

	const finishEditing = () => setIsEditing(false);

	return (
		<div className={styles.panel}>
			<div className={styles.titleRow}>
				<div className={styles.titleWrapper}>
					{isSelectBase ? (
						<div className={styles.title}>Deseja usar alguma região como base?</div>
					) : isEditing ? (
						<input
							className={styles.nameInput}
							value={regionName}
							onChange={(e) => onNameChange(e.target.value)}
							onBlur={finishEditing}
							onKeyDown={(e) => e.key === 'Enter' && finishEditing()}
							autoFocus
						/>
					) : (
						<span className={styles.title}>{regionName}</span>
					)}
				</div>

				{!isSelectBase && !isEditing && (
					<button className={styles.editBtn} onClick={() => setIsEditing(true)}>
						<EditSquare sx={{ fontSize: '1rem' }} />
						<span>Editar</span>
					</button>
				)}
			</div>

			{hasToken ? (
				<div className={styles.mapContainer}>
					<BrazilMapGL selectedStateCodes={selectedStateCodes} />
				</div>
			) : (
				<div className={styles.statesContainer}>
					{selectedStateCodes.length === 0 ? (
						<span className={styles.noStates}>
							{isSelectBase ? 'Selecione uma região à esquerda' : 'Nenhum estado selecionado'}
						</span>
					) : (
						<>
							<span className={styles.statesLabel}>
								{selectedStateCodes.length} estado{selectedStateCodes.length !== 1 ? 's' : ''}{' '}
								selecionado{selectedStateCodes.length !== 1 ? 's' : ''}
							</span>
							<div className={styles.statesGrid}>
								{selectedStateCodes.map((code) => (
									<span key={code} className={styles.stateChip}>
										{code}
									</span>
								))}
							</div>
						</>
					)}
				</div>
			)}

			<div className={styles.actions}>
				<div className={styles.editActions}>
					{isSelectBase ? (
						<Button variant="primary" className={styles.actionBtn} onClick={onSkip}>
							Não
						</Button>
					) : (
						<Button variant="primary" className={styles.actionBtn} onClick={onConfirm}>
							{isEditMode ? 'Salvar' : 'Adicionar'}
						</Button>
					)}
				</div>
			</div>
		</div>
	);
};
